import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Follower',
  steps: {
    upload: 'Carica',
    validate: 'Conferma',
    finish: 'Fatto',
  },
  labels: {
    import: 'Importa',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
